import { sanitizeUrl } from '@braintree/sanitize-url';

const BLOCKED_URL = 'about:blank';

export interface WrappedLocation {
  assign(url: string): void;
  replace(url: string): void;
  reload(): void;
  href: string;
  origin: string;
  pathname: string;
  hash: string;
  search: string;
}

const location: WrappedLocation = {
  assign(url: string) {
    window.location.assign(sanitizeUrl(url) === BLOCKED_URL ? BLOCKED_URL : url);
  },

  replace(url: string) {
    window.location.replace(sanitizeUrl(url) === BLOCKED_URL ? BLOCKED_URL : url);
  },

  reload() {
    window.location.reload();
  },

  get href() {
    return window.location.href;
  },

  get pathname() {
    return window.location.pathname;
  },

  get hash() {
    return window.location.hash;
  },

  get origin() {
    return window.location.origin;
  },

  get search() {
    return window.location.search;
  },
};

export default location;
